import React from 'react';
import Draggable from "react-draggable";
import moment from "moment";

import { getText } from "../../helpers";

import "./default_controls_deleted_modal.css";

const columnNames = {
  "existing-preventative": "Existing Preventative Controls",
  "existing-recovery": "Existing Recovery Controls",
  "additional-preventative": "Additional Preventative Controls",
  "additional-recovery": "Additional Recovery Controls",
};

const DefaultControlsDeletedModal = (props) => {
  const controlLogsLength = props.deletedDefaultControls ? props.deletedDefaultControls.length : 0;

  return (
    <Draggable handle=".control-logs-header">
      <div className="control-logs">
        <div className="control-logs-header">
          <i className="delete icon" onClick={props.onClose}></i>
          <div id="control-logs-instructions">
            <div>Default Controls Removed</div>
          </div>
          {controlLogsLength > 0 && (
            <div id="control-logs-location">
              <div>
                The default controls below have been removed from the{" "}
                <b>{columnNames[props.controlType] || props.deletedDefaultControls[0].controlType}</b> column for{" "}
                <b>{props.deletedDefaultControls[0].work_phase_or_ambient_exposure || "-"}</b>{" "}
                {">"} <b>{props.deletedDefaultControls[0].activity || "-"}</b> {">"}{" "}
                <b>{props.deletedDefaultControls[0].hazard || "-"}</b> {">"}{" "}
                <b>{props.deletedDefaultControls[0].unwanted_event || "-"}</b>.
              </div>
            </div>
          )}
        </div>

        <div className="control-logs-content">
          <table className="table control-logs-table">
            <thead>
              <tr>
                <th className="date-header">Date Removed</th>
                <th className="description-header">{getText("Description")}</th>
              </tr>
            </thead>
            <tbody>
              {controlLogsLength > 0 ? (
                props.deletedDefaultControls.map((log, index) => (
                  <tr key={index}>
                    <td>{moment(log.created_at).format("DD MMM YYYY hh:mm A")}</td>
                    <td>
                      <div style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                        <b>{log.user}</b> has removed default control '<b>{(log.control && log.control.name) ? log.control.name : "(unknown)"}</b>'.
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={2}>No default controls removed for this risk and column.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </Draggable>
  );
};

export default DefaultControlsDeletedModal;



// WEBPACK FOOTER //
// ./src/views/default_controls_deleted_logs/default_controls_deleted_modal.js